export default "__VITE_ASSET__51b1209f__"